"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerConverter = void 0;
var _reactResponsive = require("react-responsive");
var _reactHookForm = require("react-hook-form");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _decimal = _interopRequireDefault(require("decimal.js"));
var _ui = require("../../../../ui");
var _form = require("../../form");
var _hooks = require("../../../../../hooks");
var _fields = require("../../../../fields");
var _utils = require("../../../../../utils");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputCurrencyText = (0, _styledComponents.default)(_ui.MediumSpan)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var TickerConverter = function TickerConverter() {
  var _props$price, _props$price2, _props$price$value, _props$price3;
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.md
  });
  var _useFormContext = (0, _reactHookForm.useFormContext)(),
    control = _useFormContext.control;
  var props = (0, _hooks.useExchangeContext)();
  var _useTranslation = (0, _hooks.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_form.TickerConverter, null, /*#__PURE__*/_react.default.createElement(_form.TickerConverterFormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    className: "d-flex justify-content-between"
  }, t('amountToSend'), ":"), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/_react.default.createElement(InputCurrencyText, null, props.toTicker)), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: control,
    inputProps: {
      name: 'toAmount',
      onFocus: props.onToAmountInputFocus,
      onKeyDown: function onKeyDown(e) {
        props.onToAmountChange();
      },
      ticker: props.toTicker,
      decimals: new _decimal.default(props.exchangePair.target.amountStep).dp()
    }
  }))), !isTablet && /*#__PURE__*/_react.default.createElement(_form.TickerConverterEqualIcon, null), /*#__PURE__*/_react.default.createElement(_form.TickerConverterFormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('amountToWithdraw'), ":"), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/_react.default.createElement(InputCurrencyText, null, props.ticker)), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: control,
    inputProps: {
      name: 'amount',
      onFocus: props.onAmountInputFocus,
      onKeyDown: function onKeyDown(e) {
        props.onAmountChange();
      },
      ticker: props.ticker,
      decimals: new _decimal.default(props.exchangePair.exchange.amountStep).dp()
    }
  })), !props.priceLoading && /*#__PURE__*/_react.default.createElement(_form.Rate, {
    ticker: (_props$price = props.price) === null || _props$price === void 0 ? void 0 : _props$price.pair[0],
    convertedTicker: (_props$price2 = props.price) === null || _props$price2 === void 0 ? void 0 : _props$price2.pair[1],
    price: (_props$price$value = (_props$price3 = props.price) === null || _props$price3 === void 0 ? void 0 : _props$price3.value) !== null && _props$price$value !== void 0 ? _props$price$value : '0'
  })));
};
exports.TickerConverter = TickerConverter;